import api from "./axiosInstance";

export const getClearanceProducts = async ({ halaman, jumlah, token }) => {
  const res = await api.get(`${process.env.REACT_APP_ERP_URL}api_web/controler/hoops/clearance.php`,
    {
      params: {
        index: 1,
        halaman,
        jumlah,
      },
      headers: {
        Authorization: token,
        "Content-Type": "text/plain",
      },
    }
  );

  return res.data;
};